// extracted by mini-css-extract-plugin
module.exports = {"switch":"CandorSwitch_switch__CAT0n"};